import { useFetch } from './useFetch'

export const useSolicitacaoVestigioService = () => {
  const fetch = useFetch()

  const listarSolicitacoesVestigio = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`solicitacoesvestigio/`)
      return response.data.solicitacoes
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarSolicitacoesVestigioCentralCustodia = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`solicitacoesvestigio/centralcustodia`)
      return response.data.solicitacoes
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarSolicitacoesVestigioDeUsuario = async (setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`solicitacoesvestigio/minhassolicitacoes`)
      return response.data.solicitacoes
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const criarSolicitacaoVestigio = async (vestigios, dadosSolicitacao, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dados = {
        ...dadosSolicitacao,
        vestigios: vestigios,
      }
      const response = await fetch.post(`solicitacoesvestigio/`, dados)
      return response.data
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const alterarStatusSolicitacao = async (id, status, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.post(`solicitacoesvestigio/${id}/alterarstatus`, { status: status })
      return response.data
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    listarSolicitacoesVestigio,
    listarSolicitacoesVestigioDeUsuario,
    criarSolicitacaoVestigio,
    alterarStatusSolicitacao,
    listarSolicitacoesVestigioCentralCustodia,
  }
}
